export function shouldUseLocalData(_window = window) {
  if (_window.location.hostname !== 'localhost') return false;
  if (_window.hasOwnProperty('environment') && _window.environment !== 'local') return false;
  if (!_window.location.href.match('localdata=on')) return false;
  return true;
}


// WEBPACK FOOTER //
// ./src/util/local.js